var React = require('react');

function IconDiscover (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"icomoon-ignore","key":0}),React.createElement("path",{"fill":"none","stroke":"#00d664","strokeLinejoin":"round","strokeLinecap":"round","strokeMiterlimit":"4","strokeWidth":"56.8889","d":"M737.659 383.052c0 195.844-158.763 354.607-354.607 354.607s-354.607-158.763-354.607-354.607c0-195.844 158.763-354.607 354.607-354.607s354.607 158.763 354.607 354.607z","key":1}),React.createElement("path",{"fill":"none","stroke":"#00d664","strokeLinejoin":"round","strokeLinecap":"round","strokeMiterlimit":"4","strokeWidth":"56.8889","d":"M640.948 640.948l354.607 354.607","key":2})]);
}

IconDiscover.defaultProps = {"version":"1.1","width":"1024","height":"1024","viewBox":"0 0 1024 1024"};

module.exports = IconDiscover;

IconDiscover.default = IconDiscover;
